export const actionsAfterOverwrite = {
    UPDATE_BUNDLES: 'update bundles',
    UPDATE_SENSORS: 'update sensors',
};
